import { type GetUserResponse, getUser } from '@otter-ai/recall-client';
import type { AdditionalQueryOptions } from '@/shared/utils/queryCreators';
import { HOUR_MS } from '../constants/time';

const userQueryKey = ['user'] as const;
type UserQueryKey = typeof userQueryKey;

const staleTime = 2 * HOUR_MS;

type AdditionalUserQueryOptions = AdditionalQueryOptions<
  GetUserResponse,
  UserQueryKey
>;

export type UserQuery = {
  readonly queryKey: UserQueryKey;
  readonly queryFn: () => Promise<GetUserResponse>;
} & AdditionalUserQueryOptions;

export function userQueryCreator(
  additionalOptions: AdditionalUserQueryOptions = {},
): UserQuery {
  return {
    staleTime,
    queryKey: userQueryKey,
    queryFn: async () => {
      const response = await getUser({ throwOnError: true });
      return response.data;
    },
    ...additionalOptions,
  };
}
